import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";

export default function Layout({ children }) {
  const location = useLocation();

  const services = ["instagram", "facebook", "twitter", "youtube", "tiktok", "soundcloud"];

  const hasHeaderTriangle = useMemo(
    () =>
      location.pathname === "/resetPassword" ||
      location.pathname === "/blog" ||
      location.pathname.includes("/blog/") ||
      location.pathname === "/contact" ||
      location.pathname === "/faq" ||
      location.pathname.includes("/buy-") ||
      location.pathname.includes("/services/") ||
      services.some((s) => location.pathname.includes(`/${s}/`)) ||
      location.pathname.includes("/service/") ||
      location.pathname.includes("/posts/") ||
      location.pathname.includes("/termsOfService") ||
      location.pathname.includes("/privacyPolicy") ||
      location.pathname.includes("/testimonials") ||
      location.pathname.includes("/cart") ||
      location.pathname.includes("/checkout") ||
      location.pathname.includes("/previewUsers") ||
      location.pathname.includes("/items") ||
      location.pathname.includes("/updateMenu") ||
      location.pathname.includes("/helpDesk") ||
      location.pathname.includes("/orders") ||
      location.pathname.includes("/billing") ||
      location.pathname.includes("/settings"),
    [location.pathname]
  );

  const isNonDashboard = useMemo(
    () =>
      location.pathname === "/" ||
      location.pathname === "/*" ||
      location.pathname === "/login" ||
      location.pathname === "/signup" ||
      location.pathname.includes("/buy-") ||
      location.pathname.includes("/services") ||
      services.some((s) => location.pathname.includes(`/${s}/`)) ||
      location.pathname.includes("/service") ||
      location.pathname === "/updateMenu" ||
      location.pathname.includes("/getstarted"),
    [location.pathname]
  );

  const isDashboard = useMemo(
    () =>
      location.pathname === "/orders" ||
      location.pathname === "/billing" ||
      location.pathname === "/settings" ||
      location.pathname === "/previewUsers" ||
      location.pathname === "/items" ||
      location.pathname === "/helpDesk",
    [location.pathname]
  );

  return (
    <>
      <Helmet>
        <title>Dailysocialboost</title>
        {/* <meta property="og:title" content="Your Open Graph Title" />
				<meta property="og:description" content="Your Open Graph Description" />
				<meta property="og:image" content="URL to the image" />
				<meta property="og:url" content="URL of the page" />

				<meta name="twitter:card" content="summary" />
				<meta name="twitter:title" content="Your Twitter Card Title" />
				<meta name="twitter:description" content="Your Twitter Card Description" />
				<meta name="twitter:image" content="URL to the image" /> */}
      </Helmet>
      <header className="w-full h-40 py-8 bg-gradient-to-r from-gray-300/5 via-gray-300/25 to-pink-350/25 relative  ">
        <Header />
        {hasHeaderTriangle ? (
          <>
            {location.pathname.includes("/getstarted/") ? (
              ""
            ) : (
              <div className="menu-triangle-left absolute align-bottom"></div>
            )}
            <div
              className={`${
                location.pathname.includes("/buy-") ||
                location.pathname.includes("/services/") ||
                services.some((s) => location.pathname.includes(`/${s}/`)) ||
                location.pathname.includes("/service/") ||
                location.pathname.includes("/posts/")
                  ? "menu-triangle-right-purple"
                  : "menu-triangle-right "
              } absolute  align-bottom`}
            ></div>
          </>
        ) : null}
      </header>

      {location.pathname === "/blog" ? (
        <div className="header-class after:absolute after:flex after:h-16 after:w-full before:absolute before:flex before:h-16 before:w-full"></div>
      ) : null}

      {isNonDashboard ? (
        <div className="w-full">
          <main className="flex flex-col grow bg-white">{children}</main>
        </div>
      ) : (
        <div className="container mx-auto px-5 lg:px-24 flex flex-col lg:flex-row bg-white">
          {isDashboard ? (
            <>
              <aside className="basis-1 px-28 lg:px-3 lg:basis-1/5 h-full mt-20">
                <Sidebar />
              </aside>
              <main className="basis-1 lg:basis-4/5">{children}</main>
            </>
          ) : (
            <main className="flex flex-col grow">{children}</main>
          )}
        </div>
      )}
      <div className="flex flex-col bg-white ">
        <Footer />
      </div>
    </>
  );
}
